<script setup lang="ts">
import Tooltip from '~/components/common/Tooltip.vue';

type Props = {
  theme: 'light' | 'dark';
  position?: 'left' | 'right';
};

withDefaults(defineProps<Props>(), { position: 'right' });
defineSlots<{
  default(props: unknown): VNode;
}>();
</script>

<template>
  <Tooltip>
    <template #trigger>
      <div class="icon" :class="{ [`icon--${theme}`]: true, [`icon--${position}`]: true }">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="10" r="7.25" stroke="currentColor" stroke-width="1.5" />
          <path
            d="M9.125 11.583h1.246v-.312c0-.179.025-.334.075-.467.053-.132.145-.258.274-.376.132-.118.317-.245.553-.381.243-.147.45-.308.618-.484.168-.179.295-.38.381-.601.09-.222.134-.47.134-.741V8.21c0-.394-.102-.743-.306-1.047a2.047 2.047 0 0 0-.86-.715c-.364-.175-.792-.263-1.283-.263-.53 0-.98.095-1.348.285a2.024 2.024 0 0 0-.849.773c-.193.33-.299.704-.317 1.123v.01L8.7 8.371l.01-.005c.012-.219.067-.408.167-.57.1-.164.237-.291.409-.381.172-.09.37-.134.596-.134.229 0 .428.043.596.129a.972.972 0 0 1 .398.349c.093.143.14.31.14.5v.01c0 .175-.03.33-.087.462a1.029 1.029 0 0 1-.28.376 3.483 3.483 0 0 1-.525.381 2.897 2.897 0 0 0-.602.468 1.392 1.392 0 0 0-.328.547c-.064.2-.09.434-.075.699l.006.381Zm.682 2.551c.272 0 .488-.075.65-.225.16-.154.241-.36.241-.618s-.08-.462-.242-.612c-.16-.154-.377-.231-.65-.231-.268 0-.485.077-.65.23-.16.151-.241.355-.241.613s.08.464.242.618c.164.15.381.225.65.225Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </template>

    <slot />
  </Tooltip>
</template>

<style lang="scss" scoped>
.icon {
  --margin: 0.25rem;

  display: inline-flex;

  &--dark {
    color: var(--white);
  }

  &--light {
    color: var(--blue-dark);
  }

  &--left {
    margin-right: var(--margin);
  }

  &--right {
    margin-left: var(--margin);
  }
}
</style>
